import React, { FunctionComponent, memo } from 'react';
import { Grid, Typography, Link as MaterialLink, Box } from '@material-ui/core';
import RoomIcon from '@material-ui/icons/Room';
import summaryLinksStyles from './SummaryLinksStyles';
import clsx from 'clsx';
import CalculatorIcon from '../../../../presentational/icons/CalculatorIcon';
import DriveIcon from '../../../../presentational/icons/DriveIcon';
import ValueMyCar from '../../../../presentational/icons/ValueMyCar';
import Translation from '../../../../../../common/components/translation/Translation';

export interface ISummaryLinksProps {
  postCode: string;
  openPostcodeModal: (shouldOpen: boolean, displayCloseIcon?: boolean) => void;
  isFinanceEnabled: boolean;
  isDealerSelectionEnabled: boolean;
  toggleFC: (shouldOpen: boolean) => void;
  testDriveUrl?: string;
  valueMyCarUrl?: string;
}

const SummaryLinks: FunctionComponent<ISummaryLinksProps> = memo(
  ({
    postCode,
    openPostcodeModal,
    isFinanceEnabled,
    toggleFC,
    isDealerSelectionEnabled,
    testDriveUrl,
    valueMyCarUrl,
  }) => {
    const styles = summaryLinksStyles();
    const isFullLinksDisplay = !!testDriveUrl && isDealerSelectionEnabled && !!valueMyCarUrl && isFinanceEnabled;

    return (
      <Grid
        container={true}
        spacing={2}
        wrap={'wrap'}
        justifyContent={'center'}
        className={clsx(styles.container, styles.flexDirection, { [styles.fullLinksDisplay]: isFullLinksDisplay })}
      >
        {!!valueMyCarUrl && (
          <Grid
            item={true}
            xs={'auto'}
            classes={{
              item: clsx(styles.item, { [styles.itemCentered]: !isFullLinksDisplay }),
            }}
          >
            <MaterialLink
              href={valueMyCarUrl}
              target="_blank"
              className={clsx([styles.flexDisplay, styles.newLink, styles.noUnderline])}
              data-test="summary:link:value_my_car"
            >
              <Box className={clsx([styles.editIcon, styles.icon])} component={'span'} display={'inline-block'}>
                <ValueMyCar />
              </Box>
              <Typography variant={'caption'}>
                <Translation id={'spc.customise.valueMyCar'} />
              </Typography>
            </MaterialLink>
          </Grid>
        )}
        {!!testDriveUrl && (
          <Grid
            item={true}
            xs={'auto'}
            classes={{
              item: clsx(styles.item, { [styles.itemCentered]: !isFullLinksDisplay }),
            }}
          >
            <MaterialLink
              href={testDriveUrl}
              target="_blank"
              className={clsx([styles.flexDisplay, styles.newLink, styles.noUnderline])}
              data-test="summary:link:test_drive"
            >
              <Box className={clsx([styles.editIcon, styles.icon])} component={'span'} display={'inline-block'}>
                <DriveIcon />
              </Box>
              <Typography variant={'caption'}>
                <Translation id={'spc.customise.testDrive'} />
              </Typography>
            </MaterialLink>
          </Grid>
        )}
        {isFinanceEnabled && (
          <Grid
            item={true}
            xs={'auto'}
            classes={{
              item: clsx(styles.item, { [styles.itemCentered]: !isFullLinksDisplay }),
            }}
          >
            <MaterialLink
              onClick={() => toggleFC(true)}
              className={clsx([styles.flexDisplay, styles.newLink, styles.noUnderline])}
              data-test="summary:repayment:edit"
            >
              <Box className={clsx([styles.editIcon, styles.icon])} component={'span'} display={'inline-block'}>
                <CalculatorIcon />
              </Box>
              <Typography color={'secondary'} variant={'caption'}>
                <Translation id={'spc.customise.editCalculation'} />
              </Typography>
            </MaterialLink>
          </Grid>
        )}
        {isDealerSelectionEnabled && (
          <Grid
            item={true}
            xs={'auto'}
            classes={{
              item: clsx(styles.item, { [styles.itemCentered]: !isFullLinksDisplay }),
            }}
          >
            <Typography component={'p'} data-test="label:postcode:label" variant={'caption'}>
              <RoomIcon color="secondary" className={styles.pinIcon} />
              <Translation id={'spc.customise.location'} />
              <MaterialLink
                data-test="label:postcode:link"
                onClick={() => openPostcodeModal(true, true)}
                className={styles.newLink}
              >
                {postCode}
              </MaterialLink>
            </Typography>
          </Grid>
        )}
      </Grid>
    );
  },
);

export default SummaryLinks;
